

//solo lo usaremos aqui
import {DetallePetcicion} from "../detalle-peticion/DetallePetcicion";
import {HojasCallCenterComponent} from "../../hojas-call-center.component";

export class DetallePetcicionAlp {
  tipo: string = "";
  id: number = 0;
  fechaPet: string = "";
  titular: string = "";
  tel: string = "";
  provincia: string = "";
  cia: string = "";
  email: string = "";
  siniestro: string = "";
  matricula: string = "";
  servicio: string = "";
  tipoServicio: string = "";
  marca: string = "";
  modelo: string = "";
  taller: number | string = 0;
  observaciones: string = "";
  estado: string = "";
  poliza: string = "";
  id_piloto: string = "";
  ia: string = "";
  empresa: number | string = 0;
  fecha: string = "";
  agente: string = "";
  modalidad: string = "";
  afectado: string = "";
  v_veh: string = "";
  v_sus: string = "";
  danos: string = "";
  reparacion: string = "";

  constructor() { }
  private formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // getMonth() es 0-index
    const año = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    const segundos = fecha.getSeconds().toString().padStart(2, '0');

    return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
  }
  public convertirDetalle(pWeb: any): void {
    this.id = pWeb[0].id;
    this.reparacion = pWeb[0].id_reparacion.toString().trim().toUpperCase();
    this.fechaPet = pWeb[0].f_siniestro.toString().trim().toUpperCase();
    this.siniestro = pWeb[0].num_siniestro.toString().trim().toUpperCase();
    this.cia = pWeb[0].cia.toString().trim().toUpperCase();
    this.titular = pWeb[0].nombre_conductor.toString().trim().toUpperCase();
    this.tel = pWeb[0].telefono.toString().trim().toUpperCase();
    this.taller = pWeb[0].taller.toString().trim().toUpperCase();

    if(this.taller == "0"){
      this.taller = "NO ASIGNADO";
      this.servicio = ""
    }else{
      this.servicio = pWeb[0].operacion.toString().trim().toUpperCase();
    }

    this.afectado = pWeb[0].elemento_afectado.toString().trim().toUpperCase();
    this.matricula = pWeb[0].matricula.toString().trim().toUpperCase();
    this.marca = pWeb[0].marca.toString().trim().toUpperCase();
    this.modelo = pWeb[0].modelo.toString().trim().toUpperCase();
    this.v_veh = pWeb[0].version_vehiculo.toString().trim().toUpperCase();
    this.v_sus = pWeb[0].vehiculo_sustitucion.toString().trim().toUpperCase();
    this.danos = pWeb[0].danos.toString().trim().toUpperCase();
    this.observaciones = pWeb[0].observaciones.toString().trim().toUpperCase();
    this.modalidad = pWeb[0].modalidad.toString().trim().toUpperCase();

    this.estado = this.convertirEstadoContact(pWeb[0].estado_contact);
  }


  public convertiHoja(hojaprin: HojasCallCenterComponent, tipo:string){
    
    hojaprin.idAlphabet = this.id.toString().trim();

    if (tipo === "DRIVALIA") {
      hojaprin.onEntradaLlamadaSelected("200000104", this.taller.toString().padStart(3, '0'));

    }else if (tipo === "OVERLEASE"){
      hojaprin.onEntradaLlamadaSelected("100000034", this.taller.toString().padStart(3, '0'));
    
    }else{
      hojaprin.onEntradaLlamadaSelected("100000038", this.taller.toString().padStart(3, '0'));
    }

    hojaprin.asegurado.nombre = this.cia.toString().trim();
    hojaprin.asegurado.tel1 = this.tel.toString().trim();
    this.fechaReal(hojaprin, this.fecha);
    hojaprin.asegurado.siniestro = this.siniestro.toString().trim() + "-" + this.reparacion.toString().trim();
    hojaprin.vehiculo.matricula = this.matricula.toString().trim().replace("-", "");
    hojaprin.asegurado.poliza = this.poliza.toString().trim();
    hojaprin.rellenarMat(this.marca, this.modelo, "", "");

  }

  public  fechaReal(hojaprin: HojasCallCenterComponent, fecha:string){
    if (fecha && fecha.trim() != ""){
      let fechaPorDefecto = new Date(fecha);
      let mes = fechaPorDefecto.getMonth() + 1;
      let dia = fechaPorDefecto.getDate();
      let ano = fechaPorDefecto.getFullYear();
      hojaprin.asegurado.fecSin = `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;
    }

  }
  private convertirEstadoContact(numeroEstado: number | string): string {
    /*
      0 => Pendiente  => P
      1 => Gestionada => G
      2 => Rellamada  => R
    */
    switch (numeroEstado) {
      case 0:
      case "0":
        return "p";
      case 1:
      case "1":
        return "g";
      case 2:
      case "2":
        return "r";
      default: break;
    }
    return "";
  }

  public convertirEstadoUpdate(letraEstado: string): string {
    /*
      0 => Pendiente  => P
      1 => Gestionada => G
      2 => Rellamada  => R
    */
    switch (letraEstado) {
      case "p":
        return "0";
      case "g":
        return "1";
      case "r":
        return "2";
      default: break;
    }
    return "";
  }
}